import React from "react";
import { errorToast, successToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
import PageHeader from "./common/pageheader";
import moment from "moment";
export default class EWallet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      walletaddress: "",
      amount: "",
      tableData: [],
      payoutwallet: "0",
      paidAmount: "",
      paymentMode: "",
      bank: "",
      date: "",
      paymentRefNumber: "",
      remarks: "",
      attachment: "",
      amountForDep: "",
      depositmessage: ""
    }
  }
  componentDidMount() {
    this.getReport();
  }

  async ewalletRequest() {
    if (!this.state.paidAmount) {
      errorToast("Enter valid paid amount");
      return;
    } else if (!this.state.paymentMode) {
      errorToast("Enter valid payment mode");
      return;
    } else if (!this.state.bank) {
      errorToast("Enter valid bank");
      return;
    } else if (!this.state.date) {
      errorToast("Enter valid date");
      return;
    } else if (!this.state.paymentRefNumber) {
      errorToast("Enter valid reference number");
      return;
    } else if (!this.state.attachment) {
      errorToast("Select valid attachment");
      return;
    }
    let t = new FormData();
    t.append("token", localStorage.getItem("token"));
    t.append("PaidAmount", this.state.paidAmount);
    t.append("PaymentMode", this.state.paymentMode);
    t.append("Bank", this.state.bank);
    t.append("rDate", moment(this.state.date).format("MM/DD/yyyy"));
    t.append("RefNumber", this.state.paymentRefNumber);
    t.append("Remarks", this.state.remarks);
    t.append("Attachment", this.state.attachment);
    let res = await ApiRequest("ewallet_request.asp", "POST", t, null);
    console.log(res);
    if (res.status === "error") {
      if (res.message === "Session Expired") {
        errorToast(res.message);
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    successToast(res.message);
    this.setState({
      amount: "",
      paidAmount: "",
      paymentMode: "",
      bank: "",
      date: "",
      paymentRefNumber: "",
      remarks: "",
      attachment: "",
      amountForDep: "",
      depositmessage: ""
    });
    this.getReport();
  }
  async getReport() {
    let res = await ApiRequest("ewallet_request_report.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      if (res.message === "Session Expired") {
        errorToast(res.message);
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      tableData: res.items
    });
  }
  render() {
    return (
      <div>
        <PageHeader title="SNS Wallet" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>SNS Wallet Request</h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="text-center table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                    <tbody>
                      <tr>
                        <td>Paid Amount</td>
                        <td>:</td>
                        <td><input type="text" className="col-lg-12 col-md-12 form-control header-search" onChange={(e) => {
                          this.setState({
                            paidAmount: e.target.value
                          })
                        }} value={this.state.paidAmount} /></td>
                      </tr>
                      <tr>
                        <td>Payment Mode</td>
                        <td>:</td>
                        <td>
                          <select className="col-lg-12 col-md-12 form-control header-search" onChange={(e) => {
                            this.setState({
                              paymentMode: e.target.value
                            })
                          }} value={this.state.paymentMode}>
                            <option value="">Select payment mode</option>
                            <option value="imps">IMPS</option>
                            <option value="neft">NEFT</option>
                            <option value="cash">CASH DEPOSIT</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>Bank</td>
                        <td>:</td>
                        <td><input type="text" className="col-lg-12 col-md-12 form-control header-search" onChange={(e) => {
                          this.setState({
                            bank: e.target.value
                          })
                        }} value={this.state.bank} /></td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td>:</td>
                        <td>
                          <div className="input-group"><span className="input-group-prepend"><span className="input-group-text"><i className="fe fe-calendar"></i></span></span><input type="date" className="form-control daterange-single" id="start_date" name="start_date" placeholder="Date" onChange={(e) => {
                            this.setState({
                              date: e.target.value
                            })
                          }} value={this.state.date} /></div>
                        </td>
                      </tr>
                      <tr>
                        <td>Payment Ref Number</td>
                        <td>:</td>
                        <td><input type="text" className="col-lg-12 col-md-12 form-control header-search" onChange={(e) => {
                          this.setState({
                            paymentRefNumber: e.target.value
                          })
                        }} value={this.state.paymentRefNumber} /></td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td>:</td>
                        <td><input type="text" className="col-lg-12 col-md-12 form-control header-search" onChange={(e) => {
                          this.setState({
                            remarks: e.target.value
                          })
                        }} value={this.state.remarks} /></td>
                      </tr>
                      <tr>
                        <td>Attachments</td>
                        <td>:</td>
                        <td><input type="file" className="col-lg-12 col-md-12" accept="image/*" onChange={(e) => {
                          this.setState({
                            attachment: e.target.files[0]
                          })
                        }} /></td>
                      </tr>
                      <tr>
                        <td colSpan="3"><button className="btn btn-color-1" onClick={() => { this.ewalletRequest(); }}>Request</button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                    SNS Wallet Request Report
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Method</th>
                        <th>Bank</th>
                        <th>Status</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.tableData.length <= 0 ? <tr>
                          <td colSpan="7">No Details Found</td>
                        </tr> :
                          this.state.tableData.map((item, index) => (
                            <tr key={index}>
                              <td className="tabletd">{(index + 1)}</td>
                              <td>{item.CreatedDate}</td>
                              <td>{item.amount}</td>
                              <td>{item.PaymentMode}</td>
                              <td>{item.bank}</td>
                              <td>{item.Status}</td>
                              <td>{item.Remarks}</td>
                            </tr>
                          ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}